import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import SaldosContext from "../../context/saldos/SaldosContext";
import { num } from "../mercado/utils";
import { useT } from "i18n";
import "./pregunta.css";

const SOPORTE = "soporte@panther7.com";

const fmt = (v) =>
  num(v).toLocaleString("es-PA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " USDT";

// Respuestas fijas. "ir" lleva a una pantalla del portal. "saldo" usa los datos de la cuenta (solo lectura).
const TEMAS = [
  {
    id: "depositar",
    titulo: "asistente.depositar.titulo",
    // Palabras clave en español, inglés y portugués (se comparan sin tildes ni mayúsculas).
    claves: [
      "deposit", "recarg", "fondear", "agregar fondos", "meter dinero",
      "add funds", "add money", "top up", "topup", "fund my", "put money",
      "depósito", "depositar", "recarreg", "adicionar fundos", "adicionar saldo", "colocar dinheiro",
    ],
    texto: "asistente.depositar.texto",
    ir: ["/cliente/ultradeposito", "asistente.depositar.ir"],
  },
  {
    id: "retirar",
    titulo: "asistente.retirar.titulo",
    claves: [
      "retir", "sacar", "enviar a mi", "transferir a",
      "withdraw", "cash out", "cashout", "take out", "send to my", "transfer to",
      "saque", "sacar", "enviar para minha", "transferir para",
    ],
    texto: "asistente.retirar.texto",
    ir: ["/cliente/retiro", "asistente.retirar.ir"],
  },
  {
    id: "invertir",
    titulo: "asistente.invertir.titulo",
    claves: [
      "invert", "inversion", "inversión", "proyecto", "comprar token",
      "invest", "project", "buy token",
      "investimento", "investir", "projeto",
    ],
    ir: ["/cliente/projectos", "asistente.invertir.ir"],
    texto: "asistente.invertir.texto",
  },
  {
    id: "saldo",
    titulo: "asistente.saldo.titulo",
    claves: [
      "saldo", "cuanto tengo", "cuánto tengo", "disponible", "balance", "mi dinero",
      "how much", "available", "my money", "my funds",
      "quanto tenho", "disponível", "meu dinheiro",
    ],
    saldo: true,
    ir: ["/cliente/dashboard", "asistente.saldo.ir"],
  },
  {
    id: "movimientos",
    titulo: "asistente.movimientos.titulo",
    claves: [
      "movimiento", "historial", "transaccion", "transacción", "estado de cuenta",
      "movements", "history", "transaction", "statement",
      "movimentação", "movimentações", "movimentacao", "histórico", "transação", "extrato",
    ],
    texto: "asistente.movimientos.texto",
    ir: ["/cliente/movimientos", "asistente.movimientos.ir"],
  },
  {
    id: "wallet",
    titulo: "asistente.wallet.titulo",
    claves: [
      "wallet", "billetera", "direccion", "dirección", "cripto",
      "crypto", "address",
      "carteira", "endereço", "endereco",
    ],
    texto: "asistente.wallet.texto",
    ir: ["/cliente/wallet", "asistente.wallet.ir"],
  },
  {
    id: "verificacion",
    titulo: "asistente.verificacion.titulo",
    claves: [
      "verific", "kyc", "document", "pendiente", "aprobar mi cuenta", "registro",
      "verify", "pending", "approve my account", "registration", "identity",
      "pendente", "aprovar minha conta", "cadastro", "identidade",
    ],
    texto: "asistente.verificacion.texto",
    ir: ["/cliente/user-profile", "asistente.cuenta.ir"],
  },
  {
    id: "clave",
    titulo: "asistente.clave.titulo",
    claves: ["clave", "contraseña", "contrasena", "password", "senha"],
    texto: "asistente.clave.texto",
    ir: ["/cliente/user-profile", "asistente.cuenta.ir"],
  },
  {
    id: "comision",
    titulo: "asistente.comision.titulo",
    claves: [
      "comision", "comisión", "fee", "costo", "cobran",
      "commission", "cost", "charge",
      "comissão", "comissao", "taxa", "custo", "cobram", "cobrança",
    ],
    texto: "asistente.comision.texto",
  },
];

const HUMANO = "asistente.humano";

const normal = (s) =>
  s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

function buscar(texto) {
  const q = normal(texto);
  return TEMAS.find((t) => t.claves.some((c) => q.includes(normal(c))));
}

export default function Pregunta() {
  const { t } = useT();
  const history = useHistory();
  const saldosCtx = useContext(SaldosContext);
  const saldos = saldosCtx ? saldosCtx.saldos : null;
  const [abierto, setAbierto] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [txt, setTxt] = useState("");
  const fin = useRef(null);

  useEffect(() => {
    if (abierto && msgs.length === 0) {
      setMsgs([{ de: "bot", k: "asistente.saludo" }]);
    }
  }, [abierto]); // eslint-disable-line

  useEffect(() => {
    if (fin.current) fin.current.scrollIntoView({ block: "end" });
  }, [msgs, abierto]);

  // Los mensajes guardan la clave de texto (k) para que cambien de idioma al instante; "texto" es lo que escribió la persona.
  const responder = (tema, pregunta) => {
    let k, vars, ir, mail;
    if (!tema) {
      k = HUMANO;
      vars = { correo: SOPORTE };
      mail = true;
    } else if (tema.saldo) {
      if (saldos) {
        k = "asistente.saldo.texto";
        vars = { disponible: fmt(saldos.DISPONIBLE), invertido: fmt(saldos.INVERTIDO), valor: fmt(saldos.VALORCUENTA) };
      } else {
        k = "asistente.saldo.error";
      }
      ir = tema.ir;
    } else {
      k = tema.texto;
      ir = tema.ir;
    }
    setMsgs((m) => [...m, { de: "yo", ...pregunta }, { de: "bot", k, vars, ir, mail }]);
  };

  const enviar = (e) => {
    e.preventDefault();
    const p = txt.trim();
    if (!p) return;
    setTxt("");
    responder(buscar(p), { texto: p });
  };

  const ir = (ruta) => {
    setAbierto(false);
    history.push(ruta);
  };

  return (
    <div className="p7q">
      {abierto && (
        <div className="p7q-panel" role="dialog" aria-label={t("asistente.aria")}>
          <div className="p7q-cab">
            <span>{t("asistente.preguntame")}</span>
            <button type="button" className="p7q-x" aria-label={t("asistente.cerrar")} onClick={() => setAbierto(false)}>×</button>
          </div>
          <div className="p7q-cuerpo">
            {msgs.map((m, i) => (
              <div key={i} className={"p7q-m p7q-" + m.de}>
                {m.k ? t(m.k, m.vars) : m.texto}
                {m.ir && (
                  <button type="button" className="p7q-ir" onClick={() => ir(m.ir[0])}>{t(m.ir[1])}</button>
                )}
                {m.mail && (
                  <a className="p7q-ir" href={"mailto:" + SOPORTE}>{t("asistente.soporte")}</a>
                )}
              </div>
            ))}
            <div className="p7q-sug">
              {TEMAS.map((tema) => (
                <button type="button" key={tema.id} onClick={() => responder(tema, { k: tema.titulo })}>{t(tema.titulo)}</button>
              ))}
            </div>
            <div ref={fin} />
          </div>
          <form className="p7q-form" onSubmit={enviar}>
            <input value={txt} onChange={(e) => setTxt(e.target.value)} placeholder={t("asistente.escribe")} maxLength={200} />
            <button type="submit">{t("asistente.enviar")}</button>
          </form>
          <div className="p7q-pie">{t("asistente.pie")} <a href={"mailto:" + SOPORTE}>{t("asistente.hablar")}</a></div>
        </div>
      )}
      {!abierto && (
        <button type="button" className="p7q-btn" onClick={() => setAbierto(true)} aria-label={t("asistente.abrir")}>
          {t("asistente.preguntame")}
        </button>
      )}
    </div>
  );
}
